<template>
    <div class="sp-banner">
        <span v-if="badge" class="sp-banner-new">{{ badge }}</span>
        <span class="sp-banner-text">
            <span class="sp-banner-title">{{ title }}</span>
            <span class="sp-banner-desc">{{ subtitle }}</span>
        </span>
        <router-link v-if="to" class="sp-banner-cta" :to="to">{{ ctaLabel }}</router-link>
        <button v-else class="sp-banner-cta" type="button" @click="$emit('cta')">{{ ctaLabel }}</button>
    </div>
</template>

<script>
export default {
    name: "SellerProfileBanner",
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        ctaLabel: {
            type: String,
            required: true,
        },
        to: {
            type: String,
            default: "",
        },
        badge: {
            type: String,
            default: "NEW",
        },
    },
    emits: ["cta"],
};
</script>
